var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"c-campaign-settings__header\"><span class=\"c-text c-text--normal c-text--faded\">{{ 'ssp' | translate }} {{ ':' }}</span></div><div class=\"c-campaign-settings__body layout layout--auto layout--small layout--middle\"><div class=\"layout__item\"><input style=\"width: 100%\" type=\"text\" ng-disabled=\"true\" ng-model-options=\"{ allowInvalid: true }\" ng-model=\"vm.getSspMarginName()\" ng-maxlength=\"200\" class=\"c-input\"/></div><div class=\"layout__item\"><input style=\"width: 100%\" type=\"number\" ng-model-options=\"{ allowInvalid: true }\" ng-model=\"vm.sspMargin.system_fee\" ng-maxlength=\"200\" placeholder=\"{{ 'margin' | translate }}\" number-between-validator=\"number-between-validator\" min-value=\"0.01\" max-value=\"100\" class=\"c-input\"/></div><div class=\"layout__item\"><a ng-click=\"vm.removeSspMargin()\" confirm=\"Are you sure you want to delete this SSP Margin?\" class=\"o-btn c-btn c-btn--icon c-btn--danger\"><span gg-icon=\"icon-trash\"></span></a></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/campaigns/sspMarginForm.jade
 ** module id = 675
 ** module chunks = 0
 **/